module.exports = __webpack_public_path__ + "static/media/credit-card-front.6b7c96fb.svg";